export const teamDashboardKeys = {
  all: ["autoleads", "team-dashboard"] as const,
  detail: (teamId: number) => [...teamDashboardKeys.all, teamId] as const,
}
